// extracted by mini-css-extract-plugin
export default {"order":"styles_order__ZsT4W","orderItem":"styles_orderItem__hKJDv","orderItemTitle":"styles_orderItemTitle__YiCG+","title":"styles_title__qKy1x","cost":"styles_cost__SRSfx"};